import runWithTimeout from './runWithTimeout';
import { isFeatureEnabled } from 'owa-feature-flags';

// These settings here are copied from skype code (https://shellprod.msocdn.com/swx/shared/v/1.2.29/SkypeBootstrap.min.js)
const LOAD_SKYPE_CONFIGURATION_OPTIONS = {
    platformId: 905,
    urls: ['https://a.config.skype.com', 'https://b.config.skype.com'],
    team: 'SkypeLyncWebExperience',
    version: '1.2.29.0',
};
const CONFIG_CALLBACK_NAME = 'onConfigurationLoaded';
const IS_SDF_OR_MSFT = isFeatureEnabled('ring-dogfood') || isFeatureEnabled('ring-microsoft');
const UCWA_API_KEY = IS_SDF_OR_MSFT
    ? '2a9f196e-2926-4f83-80a2-543bfbd2f75a'
    : 'b32c0389-1143-4a42-b15f-7b860f9eafbb';
const TIMEOUT = 30 * 1000;

export interface Origin {
    origin: string;
    xframe: string;
}

export interface ImplicitOAuthParams {
    origins: Origin[];
    client_id: string;
}

export interface SkypeConfiguration {
    SkypeLyncWebExperience: {
        implicitOAuthParams: ImplicitOAuthParams;
    };
}

type SkypeConfigurationCallback = (config: SkypeConfiguration) => void;

interface Skype {
    [CONFIG_CALLBACK_NAME]: SkypeConfigurationCallback;
}

interface WindowWithSkype extends Window {
    Skype: Skype;
}

export default function loadSkypeConfig(
    userSmtp: string,
    userId: string
): Promise<SkypeConfiguration> {
    let script: HTMLScriptElement;
    return runWithTimeout<SkypeConfiguration>(
        resolve => {
            const { platformId, urls, team, version } = LOAD_SKYPE_CONFIGURATION_OPTIONS;

            // Load balance
            const url = urls[Math.floor(Math.random() * urls.length)];
            const scriptUrl = `${url}/config/v1/${team}/${platformId}_${version}?apikey=${UCWA_API_KEY}&fingerprint=${userId}&id=${userSmtp}&callback=Skype.${CONFIG_CALLBACK_NAME}`;

            (<WindowWithSkype>window).Skype = {
                [CONFIG_CALLBACK_NAME]: (config: SkypeConfiguration) => resolve(config),
            };

            script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptUrl;
            document.head.appendChild(script);
        },
        () => {
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
        },
        TIMEOUT
    );
}
